import React, { useEffect } from "react";
import { Link } from "react-router-dom";

export default () => {
  useEffect(() => {
    const rootElement = document.getElementById("root");
    rootElement?.classList.add("overflow-hidden");
    return () => rootElement?.classList.remove("overflow-hidden");
  }, []);

  return (
    <div id="about">
      <div className="content">
        <h1 style={{ fontSize: 36 }}>WHY WE’RE HERE.</h1>
        <p>
          Throughout history, the artists that have endured are the visionaries—the ones who have stepped out of what’s normal and done something
          different, something revolutionary.
        </p>
        <p>They’ve created movements. They’ve started things. They’ve put their work out there and demanded to be heard.</p>
        <p>Now, it’s your turn.</p>
        <p>
          UNIFI MUSIC exists to support and amplify you, the next wave of visionary artists: You, the producers and songwriters and MCs, the
          instrumentalists and vocalists and dancers that come together to create the music we all love.
        </p>
        <p>
          UNIFI MUSIC is here to give you, the fiercely independent artist, a place to showcase your unique talents easily, and free of heavy monthly
          fees for things you don't need. We’re here to help you not have to string together six different platforms just to get your creations seen
          and heard.
        </p>
        <p>
          And fear not, fans. We're here for you, too. You, the supporters of great talent and artistry, we've created a place for you to easily
          discover the freshest new artists out there, whether you're on the hunt for your next favorite summer jam, or just need a quick
          Netflix-and-chill soundtrack.
        </p>
        <p>After all, nothing brings people together like music. And when people come together, the world is a better place.</p>
        <p>Welcome to the new world.</p>
      </div>
      <div className="x">
        <Link to="/">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="white" />
          </svg>
        </Link>
      </div>
    </div>
  );
};
